import {checkSectionVisibility} from '../Common/checkSectionVisibility';

export function populateJobs(jsonData){    
    console.log('jsonData:',jsonData);
    if(jsonData.jobs){
        jobsubHeadingText = jsonData.jobs.data.section_text.value;
    }else{
        jobsubHeadingText = "We believe that each one of us should be able to find our dream job, and we constantly strive hard to make that possible. Apply now!";
    }

    if(!$(document).find(".preview").hasClass("hidden")){
        $("p.heading-subtext").html(jobsubHeadingText);        
    }
    else{ 
        checkSectionVisibility(jsonData.jobs.visibility, $(".jobs"));                           
        $("textarea.heading-subtext").val(jobsubHeadingText);
        $("textarea.heading-subtext").css("margin", "0");
    }

    var categoryId;
    var categoryJobsData;
    var count;

    var catTitle =  {
        "11": "All",
        "13": "Banking & Finance",
        "14": "Sales & Marketing",
        "15": "IT & Systems",
        "16": "Consulting",
        "17": "HR & IR",
        "19": "SCM & Operations",
        "21": "Legal",
        "22": "BPO",
        
        "23": "Production and Logistics",
        "24": "Research and Development ",
        "25": "Sales",
        "26": "Marketing",
        "27": "Human Resource Management",
        "28": "Accounting and Finance",
        "29": "Technical",
        "30": "Operations and Services",
        "31": "Design",
        "32": "Other"
    }

    var categoryArray;

    function getJobs() {
        var job = $('.job-row.job-prototype.prototype.hidden').clone().removeClass('prototype hidden');
        return {
            element: job,
            title: job.find('.job-title'),
            location: job.find('.job-detail.location').find('.detail-value'),
            experience: job.find('.job-detail.experience').find('.detail-value'),
            url: job.find('.view-job').find("a"),
            rowURL: job.find("a#jobRowLink")
        }
    }

    function loadCourses() {        
        if(recruiterID){
            $.ajax({
                type: 'GET',
                url: baseUrl + 'jobs/' + recruiterID,
                success: function(res) {
                    categoryJobsData = JSON.parse(res.jobs);
    
                    categoryJobsData = createAllCategoryData(categoryJobsData);    
                    
                    console.log(categoryJobsData);
                    
                    
                    categoryArray = Object.keys(categoryJobsData);
                                    
                    $.each(categoryArray, function(i, item) {                        
                        var navItem = $('<li></li>');
                        navItem.attr("id", item);
                        navItem.html(catTitle[item]);
                        $('#jobCategoryList').append(navItem);
                        if(navItem.attr('id') == categoryArray[0]) {
                            navItem.addClass('active');
                            categoryId = categoryArray[0];
                        }
                    });
                    loadCategoryCourses(categoryId);
                    
                    
                }
            });
        }

        // $.getJSON('/static/js/Common/job.json', function(res){
        //     categoryJobsData = res;
        //     categoryArray = Object.keys(categoryJobsData);
                
        //         console.log("category arrat ",categoryArray);
                
        //         $.each(categoryArray, function(i, item) {

        //             var navItem = $('<li></li>');
        //             navItem.attr("id", item);
        //             navItem.html(catTitle[item]);
        //             $('#jobCategoryList').append(navItem);
        //             if(navItem.attr('id') == categoryArray[0]) {
        //                 navItem.addClass('active');
        //                 categoryId = categoryArray[0];
        //             }
        //         });
        //         loadCategoryCourses(categoryId);
        // });
    }

    function populateData(categoryJobsData, catID){
        count = 0;
        
        $.each(categoryJobsData[catID], function(Index, Item){                                       
            // if(count<5){
                var newJob = getJobs();
                newJob.title.html(Item['title']);
                newJob.experience.html(Item['min'] + "-" + Item['max'] + " yrs");
                newJob.location.html(Item['location']);
                // newJob.url.attr('href', Item['url']);

                if(count>=5){
                    newJob.element.addClass("moreJob hidden")
                }

                // if($(window).width()< 768){                    
                    newJob.rowURL.attr('href', Item['url'])
                // }
                if(Item['url'].indexOf("iimjobs.com") == -1){
                    newJob.rowURL.attr('rel', 'nofollow')
                }
                newJob.element.attr("jobId", Item['jobId'])
                newJob.element.addClass("post")

                if(!$(document).find(".preview").hasClass("hidden")){
                    newJob.element.find(".removeJob").remove();
                }
                else{
                    newJob.element.find(".removeJob").removeClass("hidden");
                }
                $('.job-listing').append(newJob.element);

                count++;
            // }
        });
        showMoreJob();
        
    }

    function createAllCategoryData(categoryJobsData){        
        var allArray = [];

        for(var key in categoryJobsData){
            $.each(categoryJobsData[key], function(i, item){
                allArray.push(item);
            });
        }

        var allObject = {
            "11": allArray
        }

        var objs = [allObject, categoryJobsData],
        result =  objs.reduce(function (r, o) {
            Object.keys(o).forEach(function (k) {
                r[k] = o[k];
            });
            return r;
        }, {});        

        return result;

        // return  Object.assign(allObject, categoryJobsData);
        
    }

    function loadCategoryCourses(id) {

        var catID = id;
        
        $(".post").remove();

        populateData(categoryJobsData, catID);
    }

    function isActive() {
        $('#jobCategoryList').on('click', 'li', function() {
            $('li').removeClass('active');
            $(this).addClass('active');
            categoryId = $(this).attr('id');
            loadCategoryCourses(categoryId);
        })
    }

    loadCourses();
    isActive();

    function showMoreJob(){ 
        // console.log("count ", count);
        
            
        var showMoreContainer = $(".show-more-container.jobsMore");
        var showMoreButton = showMoreContainer.find("button");

        // console.log(showMoreContainer);
        
        if(count>5){
            showMoreContainer.removeClass("hidden");
            showMoreButton.html("Show More Jobs");
            showMoreButton.append("<i class='icon-down_arrow'></i>");

            showMoreButton.unbind( "click" );
            
            showMoreButton.on('click', function(){
                // console.log("show more clicked");
                
                if($(".moreJob").hasClass("hidden")){                    
                    $(".job-listing").css("overflow-y", "scroll");
                    $(".moreJob.hidden:lt(5)").removeClass("hidden");                    
                    if(!$(".moreJob").hasClass("hidden")){
                        showMoreButton.html("Show Less Jobs");
                        showMoreButton.append("<i class='icon-top_arrow'></i>");
                    }
                }
                else{
                    $(".job-listing").css("overflow-y", "hidden");
                    $(".moreJob").addClass("hidden");
                    showMoreButton.html("Show More Jobs");
                    showMoreButton.append("<i class='icon-down_arrow'></i>");
                }
            });
        }
        else{
            showMoreContainer.addClass("hidden"); 
        }
        
    }


    // if(!($(document).find(".preview").hasClass("hidden"))){
    //     showMoreJob();
    // }
}